<template>
  <div
    class="position-page"
  >
    <van-image
      width="10rem"
      height="calc(100vh - 54px)"
      class="abs animated1s fadeIn"
      style="z-index: 0;"
      :src="require('@/imgs/index/position/bg.png')"
      :show-error="false"
      :show-loading="false"
    />
    <!-- 二级菜单 -->
    <!-- 导航 -->
    <div
      :class="`sub-menu-view animated1s`"
    >
      <div style="width: 10rem;height: 30px" />
      <div :class="`menu animated1s fadeInLeft flx-row-str`">
        <div
          v-for="(item, index) in NAV_INFO"
          :id="`nav-${item.id}`"
          :key="`nav-${index}`"
          class="icon-view flx-ctr"
          @click="changeCurrent(item.id)"
        >
          <van-image
            :src="item.nIcon"
            :width="`${item.nWidth || item.width}px`"
            :height="`${item.nHeight}px`"
            :show-error="false"
            :show-loading="false"
            class="icon"
          >
            <van-image
              v-if="current === item.id"
              :src="item.hIcon"
              :width="`${item.width}px`"
              :height="`${item.height}px`"
              :show-error="false"
              :show-loading="false"
              class="abs icon"
              style="top: -73%;left:-25%"
            />
          </van-image>
        </div>
      </div>
    </div>
    <div class="left-tips abs-b flx-row-btw">
      <span style="margin-left: 12px">&lt;&lt;</span>
      <span>左右滑动查看更多</span>
      <span style="margin-right: 12px">>></span>
    </div>
    <!-- 内容 -->
    <van-swipe
      ref="position-swiper"
      class="position-swiper"
      :show-indicators="false"
      :autoplay="0"
      :loop="true"
      @change="currentChange"
    >
      <van-swipe-item
        v-for="(item, index) in BOOK_INFO"
        :key="index"
        class="swiper-item flx-col-ctr"
        height="calc(100vh - 54px)"
      >
        <template v-if="current == index">
          <van-image
            :src="item.src"
            :show-error="false"
            :show-loading="false"
            :width="`${item.width || '8rem'}`"
            class="animated1s fadeIn"
          >
            <!-- <van-image
              :src="require('@/imgs/index/position/gh_menu_light.png')"
              :show-error="false"
              :show-loading="false"
              style="width: 100px;height: 100px;border: 1px solid red;left: 30%;top: 20%"
              class="abs"
            /> -->
          </van-image>
        </template>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { BOOK_INFO, NAV_INFO } from '@/libs/config/position';
import { Swipe, SwipeItem } from 'vant';

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      NAV_INFO,
      BOOK_INFO,
      current: 0,
    };
  },
  methods: {
    currentChange(index) {
      this.current = index;
      if (index < 3) {
        this.scrollIntoView(1);
      } else {
        this.scrollIntoView(8);
      }
    },
    changeCurrent(index) {
      this.current = index;
      this.$refs['position-swiper'].swipeTo(index);
      if (index < 5) {
        this.scrollIntoView(1);
      } else {
        this.scrollIntoView(8);
      }
    },
    scrollIntoView(id) {
      this.$nextTick(() => {
        document.getElementById(`nav-${id}`).scrollIntoView({ behavior: 'smooth', inline: 'end' });
      });
    },
  },
};
</script>

<style lang="less" scope>
.position-page {
  position: relative;
  width: 10rem;
  height: calc(100vh - 54px);
  background-color: #fefefe;
  background-size: cover;
  background-position: 100%;
  .sub-menu-view {
    position: absolute;
    width: 10rem;
    bottom: 0;
    left: 0;
    z-index: 2001;
    transition: all .5s linear;
    background-image: linear-gradient(to right , #212125, #212125);
    background-size: 100% 60px;
    background-position: 0% 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-repeat: no-repeat;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .menu {
      flex-shrink: 0;
      height: 46px;
      margin-bottom: 12px;
      white-space: nowrap;
    }
    .icon-view {
      display: inline-block;
      margin: 3px 8px;
    }
    .more {
      width: 100%;
      padding: 5px 0;
      background-color: #212125;
      margin-top: -1px;
      transition: width .5s linear;
      &.hide {
        width: 54px;
        height: 44px;
        padding: 0;
        margin-left: -22px;
        border-radius: 22px;
        & .van-image {
          margin-left: 16px;
          transform: rotate(180deg);
        }
      }
    }
  }
  .left-tips {
    width: 10rem;
    font-size: 8px;
    color: rgba(255, 255, 255, .4);
    bottom: 4px;
    z-index: 2002;
  }
  .bg-img {
    filter: blur(50px);
  }
  .position-swiper {
    width: 10rem;
    height: calc(100% - 44px);
  }
  .swiper-item {
    width: 10rem;
    height: 100%;
  }
  .title {
    margin-top: 3vh;
  }
  .content {
    margin-top: 3vh;
  }
  .foot {
    margin-top: 4vh;
  }
}
</style>
